import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_document_approval_sequence_RowClass} from '../../../dbschema';

export class ClaimDocumentApprovalSequenceContainerModel extends BaseContainerModel {
  bl_aat_claim_document_approval_sequence: bl_aat_claim_document_approval_sequence_RowClass = new bl_aat_claim_document_approval_sequence_RowClass();
}
